import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';
import url from '../../constants/config';

const getAuthHeader = () => ({
  Authorization: `Bearer ${window.localStorage.getItem('authorization')}`,
});

const timeTrackingSlice = createSlice({
  name: 'timeTracking',
  initialState: {
    entries: [],
    players: [],
    loading: false,
    error: null,
    defaultRate: null,
  },
  reducers: {
    setEntries: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.entries = action.payload;
    },
    addEntry: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.entries = [action.payload, ...state.entries];
    },
    replaceEntry: (state, action) => {
      const idx = state.entries.findIndex(e => e._id === action.payload._id);
      if (idx !== -1) {
        // eslint-disable-next-line no-param-reassign
        state.entries[idx] = action.payload;
      }
    },
    removeEntry: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.entries = state.entries.filter(e => e._id !== action.payload);
    },
    setPlayers: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.players = action.payload;
    },
    setDefaultRate: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.defaultRate = action.payload;
    },
    setLoading: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.loading = action.payload;
    },
    setError: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.error = action.payload;
    },
  },
});

export const {
  setEntries,
  addEntry,
  replaceEntry,
  removeEntry,
  setPlayers,
  setDefaultRate,
  setLoading,
  setError,
} = timeTrackingSlice.actions;

export const fetchEntries = () => async dispatch => {
  dispatch(setLoading(true));
  try {
    const res = await axios.get(`${url}/time-tracking/entries`, {
      headers: getAuthHeader(),
    });
    dispatch(setEntries(res.data));
  } catch (err) {
    dispatch(setError('Nie udało się pobrać wpisów.'));
  } finally {
    dispatch(setLoading(false));
  }
};

export const fetchMyPlayers = () => async dispatch => {
  try {
    const res = await axios.get(`${url}/time-tracking/my-players`, {
      headers: getAuthHeader(),
    });
    dispatch(setPlayers(res.data.players || res.data));
    if (res.data.defaultRate !== undefined) {
      dispatch(setDefaultRate(res.data.defaultRate));
    }
  } catch (err) {
    dispatch(setError('Nie udało się pobrać zawodników.'));
  }
};

export const createEntry = data => async dispatch => {
  try {
    const res = await axios.post(`${url}/time-tracking/entries`, data, {
      headers: getAuthHeader(),
    });
    dispatch(addEntry(res.data));
    return { success: true };
  } catch (err) {
    return { success: false };
  }
};

export const updateEntry = (id, data) => async dispatch => {
  try {
    const res = await axios.put(`${url}/time-tracking/entries/${id}`, data, {
      headers: getAuthHeader(),
    });
    dispatch(replaceEntry(res.data));
    return { success: true };
  } catch (err) {
    return { success: false };
  }
};

export const deleteEntry = id => async dispatch => {
  try {
    await axios.delete(`${url}/time-tracking/entries/${id}`, {
      headers: getAuthHeader(),
    });
    dispatch(removeEntry(id));
    return { success: true };
  } catch (err) {
    return { success: false };
  }
};

export default timeTrackingSlice.reducer;
